import React from "react";
import LoginLink from "./LoginLink";
import GetPriceByEmail from "./GetPriceByEmail";
import Standard from "../Price";
import { VariantProps } from ".";
const Q = ({
  selectedProduct,
  productListingView
}: VariantProps) => {
  return <div className="map map-override mapP" data-sentry-component="Q" data-sentry-source-file="Q.tsx">
      <Standard price={selectedProduct.price.price} unitOfMeasure={selectedProduct.unitOfMeasure} textSize="small" data-sentry-element="Standard" data-sentry-source-file="Q.tsx" />
      {selectedProduct.showBelowMinimumAdvertisedPriceForLoggedInCustomers ? <p className="price enter-email">
          <LoginLink>Login</LoginLink>
          {" or enter your email to be instantly sent the price!"}
        </p> : <p className="price enter-email">
          Enter your email to be instantly sent the price!
        </p>}
      <div className="input-append">
        <GetPriceByEmail itemNumber={selectedProduct.itemNumber} className={productListingView === "list" ? "justify-start xs:justify-center" : "justify-center"} data-sentry-element="GetPriceByEmail" data-sentry-source-file="Q.tsx" />
      </div>
    </div>;
};
export default Q;